<template>
  <el-dialog :visible.sync="$parent.addPlanPopup"
    :title="activeItem.title"
    width="40%"
    v-if="$parent.addPlanPopup">
    <el-form ref="ruleForm"
      :model="ruleForm"
      label-width="80px"
      :rules="rules">
      <el-form-item label="计划名称"
        prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="选择设备"
        prop="equipment">
        <el-transfer v-model="ruleForm.equipment"
          :data="deviceList"
          filterable
          :titles="['源列表', '目标列表']"
          :props="{
            key: 'id',
            label: 'name'
          }">
        </el-transfer>
      </el-form-item>

      <el-form-item label="计划周期"
        prop="period">
        <el-input-number v-model="ruleForm.period"
          :min="1"></el-input-number>
        <span style="margin-left:20px">天/次</span>
      </el-form-item>
      <el-form-item label="执行日期"
        prop="date">
        <el-date-picker v-model="ruleForm.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="保养人员"
        prop="user">
        <el-select v-model="ruleForm.user"
          filterable
          placeholder="请选择保养人员"
          multiple
          collapse-tags
          style="width:100%">
          <el-option v-for="item in userList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.addPlanPopup = false">取 消</el-button>
      <el-button v-if="activeItem.title =='新增计划'"
        @click="submitForm('add')"
        :loadin="btnLoading">保存并激活</el-button>
      <el-button type="primary"
        :loadin="btnLoading"
        @click="submitForm('edit')">{{activeItem.title =='新增计划'?'保 存' :'确 定'}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        name: "",
        period: 1,
        date: [],
        user: [],
        equipment: [],
      },
      rules: {
        name: [
          { required: true, message: "请填写名称" },
          { whitespace: true, message: "名称不能为空" },
        ],
        period: [{ required: true, message: "请填写计划周期" }],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        user: [{ required: true, message: "请选择保养人员" }],
        equipment: [{ required: true, message: "请选择设备", trigger: "blur" }],
      },
      deviceList: [], //设备列表
      userList: [],
      btnLoading: false,
    };
  },
  methods: {
    handleActivation(type) {
      let fun = this.handleSubmit();
      Promise.all([fun])
        .then((res) => {
          let data = res[0];
          if (data && data.data.code == 200) {
            this.$message.success("添加成功");
            this.$store.commit("SET_LOADING", true);
            if (type === "add") {
              this.handleState(data.data.data.id.id);
            } else {
              this.btnLoading = false;
              setTimeout(() => {
                this.$parent.getList();
              }, 1000);
            }
            this.$parent.addPlanPopup = false;
          } else if (res && res.data.code == "00003") {
            this.btnLoading = false;
          }
        })
        .catch((err) => {});
    },
    async handleSubmit() {
      this.btnLoading = true;
      let handlersInfo = [];
      this.ruleForm.user.map((v) => {
        handlersInfo.push({ id: v });
      });
      return await api.maintenancePlanAddEditPlan({
        id: this.activeItem.id ?? null,
        name: this.ruleForm.name,
        pointIds: this.ruleForm.equipment.join(","),
        period: this.ruleForm.period,
        startTime: this.ruleForm.date[0],
        endTime: this.ruleForm.date[1],
        handlersInfo: handlersInfo,
        sourceType: "MAINTENANCE",
        planType: "CYCLE",
        planCycle: "UNLIMITED",
      });
    },
    async handleState(id) {
      let res = await api.patrolPlanChangeState({
        id: id,
        state: "ENABLE",
      });
      if (res && res.data.code == 200) {
        this.btnLoading = false;
        this.$message.success("激活成功!");
        this.$store.commit("SET_LOADING", true);
        setTimeout(() => {
          this.$parent.getList();
        }, 1000);
      }
    },
    submitForm(type) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.handleActivation(type);
        } else {
          return false;
        }
      });
    },

    async getUsetList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:baoyangguanli:maintainPlan:edit",
      });
      if (res && res.data.code == 200) {
        this.userList = res.data.data;
      }
    },
    async getEcList() {
      let res = await api.patrolGetPoutePoint({
        id: this.activeItem.routeId ?? null,
        sourceType: "MAINTENANCE",
      });
      if (res && res.data.code == 200) {
        this.deviceList = res.data.data.DEVICE;
        this.deviceList.map((v) => {
          if (v.related) {
            this.ruleForm.equipment.push(v.id);
          }
        });
      }
    },
  },
  created() {
    if (this.activeItem.id) {
      this.ruleForm.name = this.activeItem.name;
      this.ruleForm.period = this.activeItem.period;
      this.ruleForm.date[0] = this.activeItem.startTime;
      this.ruleForm.date[1] = this.activeItem.endTime;
      this.ruleForm.user = [];
      this.activeItem.handlersInfo.map((v) => {
        this.ruleForm.user.push(v.id);
      });
    }
    this.getUsetList();
    this.getEcList();
  },
};
</script>

<style lang="scss" scoped>
.addEditPlanWrap {
  max-height: 450px;
  overflow: auto;
}
</style>